﻿type EnsightenEventData = {
  name: string;
  path: string;
  type: string;
};

export type EventSyntax = {
  action?: string;
  category?: string;
  label?: string;
  value?: string;
  nonInteraction?: string;
  [key: string]: string | undefined
}

const sessionStorageGaEventTracking = 'DS_ENSIGHTEN_GAEVENT_TRACKING_ON_PAGE_REDIRECT';

export const pushVirtualPage = ({ name, path, type }: EnsightenEventData) => {
  path = path.split(/[#|?]/)[0];
  if (typeof window.dataLayer !== 'undefined') {
    if (!type) {
      type = '';
    }

    if (path !== undefined && path.charAt(0) === '/') {
      path = path.substring(1);
    }

    window.dataLayer.push({
      event: 'virtualPage',
      page: {
        virtualPath: '/virtualpath/' + path?.toLowerCase(),
        name: name.toLowerCase(),
        type: type.toLowerCase()
      }
    });
  }
};

export const pushHashAsVirtualPage = function ({ name, type }: EnsightenEventData) {
  if (!type) {
    type = window.dataLayer[0]?.page?.type || '';
  }
  const dsPrettyPrefix = DS.Config.PRETTYPREFIX || '';
  pushVirtualPage({ name, path: dsPrettyPrefix + '/' + name, type });
};

export const pushGaEvent = function (eventDetails: EventSyntax) {
  if (!('dataLayer' in window)) throw new Error('Datalayer not found');

  const trackData = {
    event: 'gaEvent',
    eventSyntax: {
      ...eventDetails
    } as EventSyntax
  };

  window.dataLayer.push(trackData);
};

export const pushGaEventOnPageRedirect = function (eventDetails: EventSyntax) {
  sessionStorage.setItem(sessionStorageGaEventTracking, JSON.stringify({
    ...eventDetails,
    path: window.location.pathname + window.location.hash,
  }));
};